import script from "./pressComponent2.vue?vue&type=script&setup=true&lang=js"
export * from "./pressComponent2.vue?vue&type=script&setup=true&lang=js"

import "./pressComponent2.vue?vue&type=style&index=0&id=c766ccfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c766ccfc"]])

export default __exports__